import React from 'react';
import { Navbar as BSNavbar, Container, Nav, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { getWebAppUrl } from '../utils/config';

const Navbar: React.FC = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <>
      {/* Minimal Top Banner */}
      <div className="top-banner-modern">
        <Container className="d-flex justify-content-center align-items-center py-2">
          <span>🔥 Lifetime Deal: $399 • Only 10 left</span>
          <a href="#pricing" className="ms-3 banner-link">
            Claim Now →
          </a>
        </Container>
      </div>

      <BSNavbar className="navbar-modern" expand="lg">
        <Container>
          <BSNavbar.Brand as={Link} to="/" className="brand-modern">
            DHS CRM
          </BSNavbar.Brand>
          <BSNavbar.Toggle aria-controls="basic-navbar-nav" />
          <BSNavbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center">
              {isHomePage ? (
                <>
                  <Nav.Link href="#features" className="nav-link-modern">Features</Nav.Link>
                  <Nav.Link href="#pricing" className="nav-link-modern">Pricing</Nav.Link>
                  <Nav.Link as={Link} to="/blog" className="nav-link-modern">Blog</Nav.Link>
                  <Nav.Link as={Link} to="/about" className="nav-link-modern">About</Nav.Link>
                </>
              ) : (
                <>
                  <Nav.Link as={Link} to="/" className="nav-link-modern">Home</Nav.Link>
                  <Nav.Link as={Link} to="/#features" className="nav-link-modern">Features</Nav.Link>
                  <Nav.Link as={Link} to="/#pricing" className="nav-link-modern">Pricing</Nav.Link>
                  <Nav.Link as={Link} to="/blog" className="nav-link-modern">Blog</Nav.Link>
                  <Nav.Link as={Link} to="/about" className="nav-link-modern">About</Nav.Link>
                </>
              )}
              <Button
                className="btn-nav-login ms-3"
                href={getWebAppUrl()}
              >
                Login
              </Button>
              <Button
                className="btn-nav-signup ms-2"
                href={`${getWebAppUrl()}/create-account`}
              >
                Get Started
              </Button>
            </Nav>
          </BSNavbar.Collapse>
        </Container>
      </BSNavbar>
    </>
  );
};

export default Navbar;
